var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { ChainId, NATIVE_ADDRESS, NATIVE_SOL, WRAPPED_SOL, ZERO_ADDRESS } from '../config/networks';
import { isEVMNetwork } from '../validation/network-validation';
import { fetchTokenPriceDefined } from './definedTokenUsdPrice';
/**
 * Retrieves the USD price of a token on a specific chain.
 * @param chainId - The ID of the chain.
 * @param tokenAddress - The address of the token.
 * @returns A promise that resolves to the USD price of the token.
 */
export function getTokenUSDPrice(chainId, tokenAddress) {
    return __awaiter(this, void 0, Promise, function () {
        var isSui, baseUrl, currencyId, url, response, error_1, priceAddress, definedPrice, price, url, payload, response, error_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    isSui = chainId === ChainId.SUI;
                    if (!(isEVMNetwork(chainId) && !isSui)) return [3 /*break*/, 5];
                    baseUrl = 'https://api.odos.xyz/pricing/token';
                    currencyId = 'USD';
                    tokenAddress =
                        tokenAddress.toLowerCase() == NATIVE_ADDRESS.toLowerCase() ? ZERO_ADDRESS : tokenAddress;
                    url = "".concat(baseUrl, "/").concat(chainId, "/").concat(tokenAddress);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get(url, {
                            params: { currencyId: currencyId },
                            headers: { accept: 'application/json' },
                        })];
                case 2:
                    response = _c.sent();
                    return [2 /*return*/, response.data.price];
                case 3:
                    error_1 = _c.sent();
                    if (axios.isAxiosError(error_1)) {
                        console.error('Axios error:', ((_a = error_1.response) === null || _a === void 0 ? void 0 : _a.data) || error_1.message);
                    }
                    else {
                        console.error('Error fetching token price:', error_1);
                    }
                    return [2 /*return*/, 0];
                case 4: return [3 /*break*/, 11];
                case 5:
                    if (!(chainId !== ChainId.SUI)) return [3 /*break*/, 7];
                    priceAddress = tokenAddress == NATIVE_SOL ? WRAPPED_SOL : tokenAddress;
                    return [4 /*yield*/, fetchTokenPriceDefined(priceAddress, ChainId.SOLANA.toString())];
                case 6:
                    definedPrice = _c.sent();
                    price = definedPrice.data.getTokenPrices[0].priceUsd;
                    return [2 /*return*/, price];
                case 7:
                    url = 'https://aftermath.finance/api/price-info';
                    payload = { coins: [tokenAddress] };
                    _c.label = 8;
                case 8:
                    _c.trys.push([8, 10, , 11]);
                    console.log('Sending request with payload:', JSON.stringify(payload, null, 2));
                    return [4 /*yield*/, axios.post(url, payload, {
                            headers: { accept: 'application/json' },
                        })];
                case 9:
                    response = _c.sent();
                    console.log("SUI price response", response.data[tokenAddress].price);
                    return [2 /*return*/, response.data[tokenAddress].price];
                case 10:
                    error_2 = _c.sent();
                    if (axios.isAxiosError(error_2)) {
                        console.error('Axios error:', ((_b = error_2.response) === null || _b === void 0 ? void 0 : _b.data) || error_2.message);
                    }
                    else {
                        console.error('Error fetching token price:', error_2);
                    }
                    return [2 /*return*/, 0];
                case 11: return [2 /*return*/];
            }
        });
    });
}
